// @flow

/**
 * Traductions produits / catégories / options écrites par le backoffice.
 * Langue de référence : français (champs `name`, `description`, `rubricName`).
 * Traductions : `<field>_trans[LANG]` (ex. `name_trans.EN`).
 */

export const DEFAULT_LANG = 'FR'
export const LANG_STORAGE_KEY = 'we-eats-lang'

export const LANGUAGES = [
  { code: 'FR', flag: '🇫🇷', label: 'Français' },
  { code: 'EN', flag: '🇬🇧', label: 'English' },
  { code: 'CN', flag: '🇨🇳', label: '中文' },
  { code: 'IT', flag: '🇮🇹', label: 'Italiano' },
  { code: 'ES', flag: '🇪🇸', label: 'Español' },
  { code: 'DE', flag: '🇩🇪', label: 'Deutsch' },
  { code: 'PT', flag: '🇵🇹', label: 'Português' },
  { code: 'JA', flag: '🇯🇵', label: '日本語' },
  { code: 'KO', flag: '🇰🇷', label: '한국어' },
]

const LANG_CODES = LANGUAGES.map((l) => l.code)

export function isValidLang(lang: any): boolean {
  return typeof lang === 'string' && LANG_CODES.includes(lang)
}

/**
 * Retourne le champ traduit de `obj` pour `lang`, avec repli sur le champ français
 * si la traduction est absente ou vide.
 */
export function getTrans(obj: ?Object, field: string, lang: ?string): string {
  if (!obj || typeof obj !== 'object') return ''
  const base = obj[field] == null ? '' : obj[field]
  if (!lang || lang === DEFAULT_LANG) return base
  const trans = obj[`${field}_trans`]
  const value = trans && typeof trans === 'object' ? trans[lang] : undefined
  if (typeof value === 'string' && value.trim() !== '') return value
  return base
}

/**
 * Langues activées dans `settings.languages` ({ FR: true, EN: false, ... }).
 * Le français est toujours inclus (langue de référence). Map absente => ['FR'].
 */
export function getActiveLanguages(settings: ?Object): Array<string> {
  const languages = settings && settings.languages && typeof settings.languages === 'object' ? settings.languages : {}
  return LANG_CODES.filter((code) => code === DEFAULT_LANG || languages[code] === true)
}

export function getStoredLang(): string {
  try {
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY)
    return isValidLang(stored) ? stored : DEFAULT_LANG
  } catch (e) {
    return DEFAULT_LANG
  }
}

export function storeLang(lang: string): void {
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang)
  } catch (e) {
    // localStorage indisponible (navigation privée, etc.) : on ignore
  }
}
